export const AREA_KEYS = ["genitori", "societa", "arbitri", "staff"];
const LAST_AREA_KEY = "fsl_last_area";
export const readLastArea = () => { try { const v = localStorage.getItem(LAST_AREA_KEY); return AREA_KEYS.includes(v) ? v : null; } catch { return null; } };
export const saveLastArea = (a) => { try { if (AREA_KEYS.includes(a)) localStorage.setItem(LAST_AREA_KEY, a); } catch { /* storage non disponibile */ } };
